import PropTypes from 'prop-types';
var rangeProp = PropTypes.shape({
  min: PropTypes.number,
  max: PropTypes.number
});
var filterProp = PropTypes.shape({
  price: rangeProp,
  beds: rangeProp,
  baths: rangeProp,
  parking: rangeProp,
  floorArea: rangeProp,
  blockSize: rangeProp,
  propertyTypes: PropTypes.arrayOf(PropTypes.string),
  listingOptions: PropTypes.arrayOf(PropTypes.string),
  listingFeatures: PropTypes.arrayOf(PropTypes.string),
  localities: PropTypes.arrayOf(PropTypes.shape({})),
  keywords: PropTypes.string
});
export default PropTypes.shape({
  sort: PropTypes.shape({
    criteria: PropTypes.string,
    order: PropTypes.string
  }),
  page: PropTypes.number,
  filters: filterProp
});